import React from 'react';
import { Check } from 'lucide-react';

interface PricingFeature {
  name: string;
}

interface PricingCardProps {
  productName: string;
  description: string;
  price: string;
  monthlyPrice?: string;
  buttonText: string;
  features: PricingFeature[];
  onSubscribe: () => void;
  isLoading?: boolean;
  billingPeriod: 'monthly' | 'yearly';
}

export const PricingCard: React.FC<PricingCardProps> = ({
  productName,
  description,
  price,
  monthlyPrice,
  buttonText,
  features,
  onSubscribe,
  isLoading = false,
  billingPeriod
}) => {
  return (
    <div className="relative bg-white rounded-2xl border border-black p-6">
      <div className="absolute -top-3 left-4">
        <span className="inline-block px-4 py-1 bg-orange-100 text-orange-700 text-xs font-medium rounded-full">
          {productName}
        </span>
      </div>
      <div className="mb-6">
        {billingPeriod === 'yearly' ? (
          <>
            <div className="flex items-baseline gap-1">
              <span className="text-4xl font-bold">{monthlyPrice}</span>
              <span className="text-gray-500">/mo</span>
            </div>
            <p className="text-sm text-gray-500 mt-1">
              Billed annually at {price}
            </p>
          </>
        ) : (
          <div className="flex items-baseline gap-1">
            <span className="text-4xl font-bold">{price}</span>
            <span className="text-gray-500">/mo</span>
          </div>
        )}
      </div>
      <h3 className="text-xl font-semibold mb-2">{productName}</h3>
      <p className="text-sm text-gray-600 mb-6">{description}</p>
      <button
        onClick={onSubscribe}
        disabled={isLoading}
        className="w-full py-2 px-4 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors mb-6 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {buttonText}
      </button>
      <ul className="space-y-4">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
            <span className="text-gray-600">{feature.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};